export const MAX_PROJECT_GOALS = 50
export const MAX_PROJECT_GOAL_DESCRIPTION_LENGTH = 1000

export function createProjectGoalId() {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID()
  }
  return `goal-${Date.now()}-${Math.random().toString(16).slice(2)}`
}

function normalizeGoalDescription(value) {
  return `${value || ''}`
    .trim()
    .slice(0, MAX_PROJECT_GOAL_DESCRIPTION_LENGTH)
}

export function normalizeProjectGoal(value, index = 0) {
  const source =
    value && typeof value === 'object' && !Array.isArray(value)
      ? value
      : { description: value }
  const description = normalizeGoalDescription(source.description)
  if (!description) return null
  const id = `${source.id || ''}`.trim() || `goal-${index + 1}`
  return { id, description }
}

export function normalizeProjectGoals(value) {
  const source = Array.isArray(value) ? value : []
  const seenIds = new Set()
  const goals = []

  source.some((item, index) => {
    const goal = normalizeProjectGoal(item, index)
    if (!goal || seenIds.has(goal.id)) return false
    seenIds.add(goal.id)
    goals.push(goal)
    return goals.length >= MAX_PROJECT_GOALS
  })

  return goals
}

export function createProjectGoal(description = '') {
  return {
    id: createProjectGoalId(),
    description: `${description || ''}`.slice(
      0,
      MAX_PROJECT_GOAL_DESCRIPTION_LENGTH,
    ),
  }
}

export function projectGoalsEqual(left, right) {
  return (
    JSON.stringify(normalizeProjectGoals(left)) ===
    JSON.stringify(normalizeProjectGoals(right))
  )
}

export function hasDuplicateProjectGoal(goals, description) {
  const wanted = normalizeGoalDescription(description).toLowerCase()
  if (!wanted) return false
  return normalizeProjectGoals(goals).some(
    (goal) => goal.description.toLowerCase() === wanted,
  )
}
